//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { Swiper, Autoplay, Lazy } from 'swiper'
import { round, floor, matomofn } from '~/assets/js/utils.js'

import 'swiper/swiper-bundle.css'
Swiper.use([Autoplay, Lazy])
export default {
  props: {
    amount: { // 页面数据
      type: Object, default: () => ({})
    },
    price: { // 最低价
      type: String, default: ''
    },
    num: { // 实时在线人数
      type: [Number, String], default: 0
    },
    list: { // 购买列表
      type: Array, default: () => []
    }
  },
  data () {
    return {
      onlineCount: '', // 实时在线人数
      volumeList: [ // 数据项
        { name: this.$t('28652'), value: 0, rise: 0 },
        { name: this.$t('28651') + '(USD)', value: 0, rise: 0 },
        { name: this.$t('19279'), value: 0, rise: 0 },
        { name: this.$t('19280'), value: 0, rise: 0 },
        { name: this.$t('19281') + '(USD)', value: 0, rise: 0 }
      ]
    }
  },
  computed: {
    // 是否为移动端
    isM () {
      return this.$store?.state?.isMobile
    },
    // 修改头像模板
    handleAvatar () {
      return (str = '') => str?.replace('_wiki-template-global', '_wiki50') || 'https://img.fx696.com//avatar/0000000000.png_wiki50'
    }
  },
  watch: {
    // 监听PC端/移动端的切换
    isM () {
      this.calScroll()
    }
  },
  created () {
    this.volumeList?.forEach((item, index) => {
      const valKey = ['lots_24h', 'brustamount_24h', 'TotalTraders', 'TotalCount', 'TotalBanlance'][index]
      const strKey = ['lots_24h_direct', 'brustamount_24h_direct', 'TotalTraders_direct', 'TotalCount_direct', 'TotalBanlance_direct'][index]
      const directionTxt = this.amount[strKey] || ''
      item.value = Number(this.amount[valKey] || 0)
      item.rise = (directionTxt != 'up' ? (directionTxt != 'down' ? 0 : -1) : 1)
    })
    this.onlineCount = this.$t('37017').replace('{0}', ` <span class="accessions-count">${this.num2CurrencyNo(Number(this.num))}</span> `)
  },
  mounted () {
    const rollTimer = setTimeout(() => { // 数字滚动
      clearTimeout(rollTimer)
      this.calScroll()
      this.initSwipe()
    }, 500)
  },
  beforeDestroy () {
    this.buySwipe?.destroy()
  },
  methods: {
    // 计算数字向上滚动的高度
    calScroll () {
      const domList = document.getElementsByClassName('roll-num')
      for (let i = 0; i < domList.length; i++) {
        const domVal = Number(domList[i]?.dataset?.val || 0) // 取该dom的dataset的val值
        const eachHeight = this.isM ? 19 : 36
        domList[i].style.marginTop = `-${domVal * eachHeight}px` // 根据val值，计算向上滚动高度
      }
    },
    matomo () {
      matomofn('Cloud_Home_VPS', {}, this.$store.state, this.$cookies)
    },
    // 绿涨红跌箭头
    arrowFn (value = 0) {
      const resNum = this.riseFn(value)
      return resNum > 0 ? (this.isRedUp() ? 'up-cn' : 'up') : (resNum < 0 ? (this.isRedUp() ? 'down-cn' : 'down') : 'normal')
    },
    // 初始化实时购买人数
    initSwipe () {
      const totalLen = this.list?.length
      if (!totalLen) return false
      this.buySwipe = new Swiper('.purchased-contain', {
        direction: 'vertical',
        slidesPerView: 1,
        autoplay: totalLen > 1 ? { delay: 2000, disableOnInteraction: false } : false,
        watchOverflow: true, // 当没有足够的slide切换时swiper会失效且隐藏导航等
        loop: totalLen > 1,
        lazy: { loadPrevNext: true },
        watchSlidesProgress: true,
        watchSlidesVisibility: true // 开启watchSlidesVisibility选项前需要先开启watchSlidesProgress，如果开启了watchSlidesVisibility，则会在每个可见slide增加一个类名
      })
    },
    // 获取多久时间前（时间戳转时间文本）
    getTimeAgo (timestamp = 0) {
      const currTimestamp = floor((new Date()).getTime() / 1000) // 当前时间戳（单位为秒）
      const diffStamp = currTimestamp - timestamp
      if (diffStamp < 60) return this.$t('37018').replace('{0}', round(diffStamp))
      else if (diffStamp < 3600) return this.$t('37019').replace('{0}', round(diffStamp / 60))
      else if (diffStamp < 86400) return this.$t('37020').replace('{0}', round(diffStamp / 3600))
      else return this.$t('37021').replace('{0}', round(diffStamp / 86400))
    }
  }
}
